import { Button, Select, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import stc from 'string-to-color';
import SpinLoader from '../../commonComponents/SpinLoader';
import { useListingCompanies } from '../../hooks/useCompanies';
import useLogout from '../../hooks/useLogout';
import { fetchAllNotifications } from '../../hooks/useOrders';
import AllNotifications from '../notifications';

const Rejections = () => {
    const { logout } = useLogout();
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [visibleRows, setVisibleRows] = useState([]);
    const [rerunning, setRerunning] = useState(false);
    const { data: companyCodeList } = useListingCompanies();

    const {
        data: notifications,
        isFetching,
        refetch,
    } = useQuery(['AllNotifications', companyCodeText], fetchAllNotifications, {
        refetchOnWindowFocus: true,
        onError: err => {
            if (err?.response?.status === 401) logout();
        },
    });

    const totalCount = Array.isArray(notifications?.data) ? notifications.data.length : 0;
    const shownCount = visibleRows.length;

    const rerunVisible = async () => {
        const actions = visibleRows.flatMap(item => item.actions || []).filter(action => action?.href);
        if (!actions.length) return;
        setRerunning(true);
        try {
            const results = await Promise.allSettled(actions.map(action => axios.post(action.href, action.body)));
            const failed = results.filter(result => result.status === 'rejected').length;
            if (failed) {
                message.error(`Reran ${actions.length - failed} of ${actions.length} item(s)`);
            } else {
                message.success(`Reran ${actions.length} item(s)`);
            }
            setTimeout(() => refetch(), 1000);
        } finally {
            setRerunning(false);
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 4,
                }}
            >
                <span style={{ fontSize: '15px', fontWeight: '600' }}>
                    Rejections : {shownCount} / {totalCount}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: '12px', fontWeight: '600' }}>Filter by client</span>
                    <Select
                        showSearch
                        size="small"
                        placeholder="Select client"
                        onChange={setCompanyCodeText}
                        className="filter_dropdown"
                        style={{ marginRight: 0 }}
                        value={companyCodeText}
                    >
                        <Select.Option key="none" value="">
                            All
                        </Select.Option>
                        {companyCodeList?.map(el => (
                            <Select.Option key={el._id} value={el.code}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: stc(el.code),
                                            width: '5px',
                                            height: '15px',
                                            marginRight: '5px',
                                        }}
                                    ></div>
                                    <span>{el.code}</span>
                                </div>
                            </Select.Option>
                        ))}
                    </Select>
                    <Button size="small" icon={<ReloadOutlined />} onClick={() => refetch()} loading={isFetching}>
                        Reload
                    </Button>
                    <Button size="small" danger onClick={rerunVisible} loading={rerunning} disabled={!shownCount || rerunning}>
                        Rerun All
                    </Button>
                </div>
            </div>
            <hr
                style={{
                    width: '100%',
                    margin: '6px 0 4px 0',
                    color: '#e8e8e8',
                }}
            />
            {isFetching && !notifications ? (
                <SpinLoader />
            ) : (
                <AllNotifications
                    compact
                    loading={isFetching}
                    notifications={notifications}
                    refetch={refetch}
                    onVisibleRowsChange={setVisibleRows}
                />
            )}
        </>
    );
};

export default Rejections;
